import 'css-chunksrc/client/pages/planzoneMembersPage/styles.scss';export default {
  "planzoneMembersPage": "_planzoneMembersPage_1q1dt_1",
  "header": "_header_1q1dt_10",
  "profileNavigation": "_profileNavigation_1q1dt_20",
  "title": "_title_1q1dt_28",
  "menu": "_menu_1q1dt_34",
  "menuRight": "_menuRight_1q1dt_42",
  "addResourceButton": "_addResourceButton_1q1dt_48",
  "main": "_main_1q1dt_61",
  "sidebar": "_sidebar_1q1dt_66",
  "content": "_content_1q1dt_77",
  "withGroups": "_withGroups_1q1dt_85",
  "resourcesList": "_resourcesList_1q1dt_89",
  "heading": "_heading_1q1dt_96",
  "label": "_label_1q1dt_106",
  "cogWheel": "_cogWheel_1q1dt_115",
  "loader": "_loader_1q1dt_124",
  "loaderMain": "_loaderMain_1q1dt_133",
  "dragged": "_dragged_1q1dt_140",
  "toggleViewButton": "_toggleViewButton_1q1dt_145",
  "cogIcon": "_cogIcon_1q1dt_157",
  "exportButton": "_exportButton_1q1dt_167"
};